import { useCallback, useEffect, useRef, useState } from "react";
import { Card } from "@/components/common";
import { useEvents } from "@/context/AppContext";
import { api } from "@/lib/api";
import { money } from "@/lib/format";

const EVENTS = ["SALE_CREATED", "SALE_UPDATED", "SALE_REASSIGNED", "SALE_DELETED", "work.updated", "rt.resync"];

// Chatter dashboard: FATTURATO TOTALE and GUADAGNO TOTALE since ever (site sales + history + past shifts), per month and per creator.
export function LifetimeCard({ uid }) {
  const [d, setD] = useState(null);
  const t = useRef(null);
  const load = useCallback(() => api.get(`/stats/lifetime/${uid}`).then((r) => setD(r.data)).catch(() => {}), [uid]);
  useEffect(() => { load(); }, [load]);
  useEvents(EVENTS, () => { clearTimeout(t.current); t.current = setTimeout(load, 500); });
  if (!d) return null;
  return (
    <Card title="Da quando hai iniziato" className="mb-3" testid="lifetime-card">
      <div className="grid grid-cols-2 gap-3 mb-3">
        <div><div className="text-[10px] uppercase text-slate-500">Fatturato totale</div><div className="num text-3xl font-extrabold text-emerald-400" data-testid="lifetime-revenue">{money(d.revenue)}</div></div>
        <div><div className="text-[10px] uppercase text-slate-500">Guadagno totale</div><div className="num text-3xl font-extrabold text-violet-300" data-testid="lifetime-earnings">{money(d.earnings)}</div></div>
      </div>
      <div className="grid md:grid-cols-2 gap-3 text-xs">
        <div data-testid="lifetime-months"><div className="font-bold mb-1 text-slate-400">Per mese</div>
          {d.months.map((m) => <div key={m.month} className="flex justify-between border-b border-[#1b1e2b] py-1"><span className="capitalize">{m.label}</span><span className="num">{money(m.revenue)} · <span className="text-violet-300">{money(m.earnings)}</span></span></div>)}</div>
        <div data-testid="lifetime-creators"><div className="font-bold mb-1 text-slate-400">Per creator</div>
          {d.creators.map((c) => <div key={c.creator_id || "none"} className="flex justify-between border-b border-[#1b1e2b] py-1"><span>{c.creator_name}</span><span className="num">{money(c.revenue)} · <span className="text-violet-300">{money(c.earnings)}</span></span></div>)}</div>
      </div>
    </Card>
  );
}
